<!-- The table header as a template since it used in 2 places: the table and the sticky header -->
<ng-template #tableHeader>
  <thead class="ig-data-table__header" [class.ig-data-table__header--is-white]="styleConfig().whiteHeader">
    <tr>
      <th *ngIf="selectable">
        <div class="ig-data-table__header-cell-inner">
          @if (multiSelect && allSelect) {
            <p-triStateCheckbox name="selectAll" (onChange)="onSelectAll($event)" [ngModel]="checkboxState" checkboxFalseIcon="pi pi-minus" [ariaLabel]="'table_selected_row_all' | uitranslate" />
          }

          <!--<p-checkbox *ngIf="multiSelect && allSelect" name="selectAll" (onChange)="onSelectAll()" [(ngModel)]="selectAll" [binary]="true" ></p-checkbox>-->
        </div>
      </th>
      <th *ngFor="let col of visibleColumns; index as colIndex">
        <div
          class="ig-data-table__header-cell-inner"
          [class.ig-data-table__header-cell-inner--is-settings]="col.type === 'settings'"
          [class.ig-data-table__header-cell-inner--is-sortable]="col.sortable"

          [ngClass]="[col.textAlign ? 'ig-data-table__header-cell-inner--is-' + col.textAlign + '-aligned' : '']"
          (igA11yLink)="onHeaderColumnClick(col)"
          [igA11yLinkVisible]="col.sortable || col.type === 'settings'"
          [attr.aria-label]="'TABLE_GEN_3.SETTINGS_MODAL.HEADLINE' | uitranslate"
        >

          <span>
            <span [ngClass]="{ 'aria-visible-hidden': col.headlineImgClass || col.type === 'settings' }" [attr.title]="col.headline">{{ col.headline }}</span>
            <i *ngIf="col.headlineImgClass && col.type !== 'settings'" [ngClass]="col.headlineImgClass.cls" [ngStyle]="col.headlineImgClass.css" [attr.title]="col.headline" aria-hidden="true"></i>

            <ng-container *ngIf="col.type === 'settings'">
              <i class="fas fa-cog" aria-hidden="true" [attr.title]="'TABLE_GEN_3.SETTINGS_MODAL.HEADLINE' | uitranslate"></i>
            </ng-container>

            <ng-container *ngIf="col.headlineTooltip">
              <i class="tooltip-icon far fa-info-circle" aria-hidden="true" [igTooltip]="col.headlineTooltip"></i>
              <span class="aria-visible-hidden">{{ col.headlineTooltip }}</span>
            </ng-container>
          </span>


          <ng-container *ngIf="col.sortable && col.dataSrc">
            <ng-container
              *ngIf="sort === col.id && sortDirection === 'DESC'; then sortDescending; else sortAscending">
            </ng-container>

            <ng-template #sortDescending>
              @let sortTitle = ('TABLE_GEN_3.SORT.DESC' | uitranslate) + (sort === col.id ? '(' + ('TABLE_GEN_3.SORT.ACTIVE' | uitranslate) + ')' : '');

              <a class="ig-sort-icon" title="{{ sortTitle }}">
                <i class="fas fa-caret-down" aria-hidden="true"></i>
                <span class="aria-visible-hidden">{{ sortTitle }}</span>
              </a>
            </ng-template>
            <ng-template #sortAscending>
              @let sortTitle = ('TABLE_GEN_3.SORT.ASC' | uitranslate) + (sort === col.id ? '(' + ('TABLE_GEN_3.SORT.ACTIVE' | uitranslate) + ')' : '');
              <a class="ig-sort-icon" title="{{ sortTitle }}" [ngClass]="{'ig-sort-icon--dimmed': sort !== col.id}">
                <i class="fas fa-caret-up" aria-hidden="true"></i>
                <span class="aria-visible-hidden">{{ sortTitle }}</span>
              </a>
            </ng-template>
          </ng-container>
        </div>

      </th>
      <th *ngIf="hasHelperCell"></th>
    </tr>
  </thead>
</ng-template>


<!-- The modal for table customizing -->
<ig-overlay-alert #settingsOverlay headline="{{ 'TABLE_GEN_3.SETTINGS_MODAL.HEADLINE' | uitranslate }}" [buttons]="settingsOverlayButtons" [advancedMode]="true">
  <ig-overlay-alert-content>
    <div class="ig-data-table__overlay">
      <p class="p-mb-2">
        {{ 'TABLE_GEN_3.SETTINGS_MODAL.INTRO' | uitranslate }}
      </p>

      <div cdkDropList cdkDropListLockAxis="y" class="ig-data-table__column-list" (cdkDropListDropped)="onColumnDrop($event)">
        <div class="ig-data-table__column-list-item ig-data-table__column-list-item--is-empty" *ngIf="userColumns?.length === 0">{{ 'TABLE_GEN_3.SETTINGS_MODAL.NONE' | uitranslate }}</div>
        <ng-container *ngFor="let column of userColumns">
          <div class="ig-data-table__column-list-item" *ngIf="getColumn(column.columnId) !== undefined && getColumn(column.columnId).type !== 'settings'" cdkDrag>
            <p-checkbox [binary]="true" [(ngModel)]="column.visible" [label]="getColumn(column.columnId).headline || ''" [inputId]="'tablecolumnvisible_' + column.columnId" (onChange)="onChangeColVisibility($event, column)"></p-checkbox>
            <i class="icon-a075_sort"></i>
          </div>
        </ng-container>
        <a class="ig-data-table__column-list-reset" (igA11yLink)="onResetColumns()">{{ 'TABLE_GEN_3.SETTINGS_MODAL.RESET' | uitranslate }}</a>
      </div>

    </div>
  </ig-overlay-alert-content>
</ig-overlay-alert>


<div
  #igDataTableWrapperLevel1

  class="ig-data-table__wrapper-level-1"

  [class.ig-data-table--is-bordered]="styleConfig().surroundingBorder"
  [class.ig-data-table--bordered-rows]="styleConfig().rowBorder"
  [class.ig-data-table--fixed-first]="fixedFirstColumn"
  [class.ig-data-table--fixed-last]="fixedLastColumn"
  [class.ig-data-table--has-helper-cell]="hasHelperCell"
  [class.ig-data-table--fixed-height]="styleConfig().tableHeight && styleConfig().tableHeight !== 'auto'"
  [class.ig-data-table--fixed-height-max]="styleConfig().tableHeight && styleConfig().tableHeight !== 'auto' && styleConfig().fluidTableHeight"
>

  <!-- The available actions for the selected rows -->
  <div class="ig-data-table__selected-actions" [class.ig-data-table__selected-actions--fixed]="fixedTableHeader" [class.ig-data-table__selected-actions--visible]="showSelectContainer" #selectedActionsContainer>

    <span class="ig-data-table__selected-count">
      <span class="ig-data-table__selected-count-icon">&#8627;</span>
      <span>{{ selection && selection!.length - (disabledSelection?.length || 0) }} / {{ total - (disabledSelection?.length || 0) }} <span *ngIf="selection && selection!.length - (disabledSelection?.length || 0) === 1">{{ 'TABLE_GEN_3.FAVORITES.SELECTED_SINGLE' | uitranslate }}</span><span *ngIf="selection && selection!.length - (disabledSelection?.length || 0) > 1">{{ 'TABLE_GEN_3.FAVORITES.SELECTED' | uitranslate }}</span></span>
    </span>

    <ul class="ig-data-table__action-list">
      <li *ngIf="showFavorite">
        <a href="javascript:void(0);" (click)="storeFavoritesBulk()">
          <i class="icon-a116_star_sharp_outline"></i>
          <span>{{ 'TABLE_GEN_3.FAVORITES.MAKE' | uitranslate }}</span>
        </a>
      </li>
      <li *ngIf="showFavorite">
        <a href="javascript:void(0);" (click)="storeUnFavoritesBulk()">
          <i class="icon-a117_star_sharp_solid"></i>
          <span>{{ 'TABLE_GEN_3.FAVORITES.UNMAKE' | uitranslate }}</span>
        </a>
      </li>
      <li *ngFor="let action of selectedActions">
        <ng-template [ngIf]="!action.hideFunc || action.hideFunc() === false">
          <a href="javascript:void(0);" (click)="action.func()" *ngIf="!action.disabled">
            <i [class]="action.icon"></i>
            <span>{{ action.label }}</span>
          </a>
          <div class="ig-color-label" *ngIf="action.disabled">
            <i [class]="action.icon"></i>
            <span>{{ action.label }}</span>
          </div>
        </ng-template>
      </li>
      <li *ngIf="!styleConfig().tableHeight || styleConfig().tableHeight === 'auto'" class="ig-data-table__action-list--is-highlighted">
        <a href="javascript:void(0);" (click)="resetSelection()">
          <i class="icon-a109_close_delete"></i>
          <span>{{ 'TABLE_GEN_3.FAVORITES.CLOSE' | uitranslate }}</span>
        </a>
      </li>
    </ul>

  </div>

  <!-- Container that fakes the hover effect on rows -->
  <div *ngIf="pointerOverTable && !rowHoverDisabled && styleConfig().hoverShadow !== false" class="ig-data-table__hover-container"></div>

  <div class="ig-data-table__wrapper-level-2" [class.ig-data-table__wrapper-level-2--has-table-grid]="tableGrid" #igDataTableWrapperLevel2>
    <!-- Left and right shadow containers for when there is horizontal scrolling -->
    <div *ngIf="horizontalScrolling" #igDataTableLeftShadow class="ig-data-table__shadow-container ig-data-table__shadow-container--left" [class.ig-data-table__shadow-container--active]="tableShadowLeft"></div>
    <div *ngIf="horizontalScrolling" #igDataTableRightShadow class="ig-data-table__shadow-container ig-data-table__shadow-container--right" [class.ig-data-table__shadow-container--active]="tableShadowRight"></div>

    <div class="ig-data-table__wrapper-level-3" #igDataTableWrapperLevel3>
      <p-contextMenu [target]="igDataTable" [model]="items" appendTo="body" *ngIf="!disableContextMenu && selectedContextMenuRowObjectUuid !== null"></p-contextMenu>
      <!-- The actual table -->
      <table class="ig-data-table" #igDataTable [class.ig-data-table--display-grid]="tableGrid">
        <ng-container [ngTemplateOutlet]="tableHeader"></ng-container>
        <tbody>
          <ng-container *ngFor="let row of data; index as rowIndex" >
            <tr [class.ig-data-table__row--is-loading]="isRowBusy(row)" (contextmenu)="handleShowContextMenu(row)">
              <ng-template #emptyRow>
                <td *ngIf="fixedFirstColumn">
                  <div class="ig-data-table__cell-inner">&nbsp;</div>
                </td>
                <td class="ig-data-table__empty-cell">
                  <div class="ig-data-table__cell-inner">&nbsp;</div>
                </td>
                <td *ngIf="fixedLastColumn">
                  <div class="ig-data-table__cell-inner">&nbsp;</div>
                </td>
              </ng-template>
              <ng-container *ngIf="isRowVisible(rowIndex); else emptyRow">
                <td *ngIf="selectable" [attr.data-e2e-test-col-id]="'_selectbox'">
                  <div class="ig-data-table__cell-inner">
                    <p-checkbox
                      *ngIf="multiSelect"
                      name="selectedRows"
                      [value]="getRowValue(row, [dataPrimaryKey])"
                      [disabled]="isSelectionDisabled(row)"
                      [inputId]="dataPrimaryKey"
                      [(ngModel)]="selectedRows"
                      [ariaLabel]="'table_selected_row' | uitranslate"
                      (onChange)="onSelectionChange()"
                    ></p-checkbox>
                    <ig-radioButton
                      *ngIf="!multiSelect"
                      name="selectedRows"
                      [value]="getRowValue(row, [dataPrimaryKey])"
                      [disabled]="isSelectionDisabled(row)"
                      [inputId]="dataPrimaryKey"
                      [(ngModel)]="selectedRow"
                      [ariaLabel]="'table_selected_row' | uitranslate"
                      (ngModelChange)="onSelectionChange()"
                    ></ig-radioButton>
                  </div>
                </td>

                <td
                  *ngFor="let col of visibleColumns"

                  [class.ig-data-table__cell--is-clickable]="col.type === 'link' && !getRowValue(row, 'disabled')"

                  [ngClass]="[col.textAlign ? 'ig-data-table__cell--is-' + col.textAlign + '-aligned' : '', col.textTransform ? 'ig-data-table__cell--text-' + col.textTransform : '']"

                  (igA11yLink)="col.type === 'link' && !getRowValue(row, 'disabled') ? onClickCell(col, row) : null"
                  [igA11yLinkVisible]="col.type === 'link' && !getRowValue(row, 'disabled')"

                  [attr.data-e2e-test-col-id]="col.id"
                >
                  <ng-template #emptyValue>
                    <span *ngIf="col.emptyValue" [attr.title]="col.emptyValue">{{ col.emptyValue}}</span>
                  </ng-template>
                  <div class="ig-data-table__cell-inner" [ngSwitch]="col.type">
                    <ng-container *ngSwitchCase="'date'">
                      <span *ngIf="col.dataSrc && getRowValue(row, col.dataSrc) !== undefined && getRowValue(row, col.dataSrc) !== null; else emptyValue" [attr.title]="getRowValue(row, [col.dataSrc]) | date: col.dateFormat || 'dd.MM.yyyy'">{{ getRowValue(row, [col.dataSrc]) | date: col.dateFormat || 'dd.MM.yyyy' }}</span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'component'">
                      <ig-table-component-insertor *ngIf="col.component" [column]="col" [row]="row" [dataChangeSubject]="dataChange$"></ig-table-component-insertor>
                    </ng-container>
                    <ng-container *ngSwitchCase="'settings'">
                      <ig-table-component-insertor *ngIf="col.component" [column]="col" [row]="row" [dataChangeSubject]="dataChange$"></ig-table-component-insertor>
                    </ng-container>
                    <ng-container *ngSwitchCase="'enum'">
                      <span *ngIf="col?.enum && col!.enum![getData(row, col)] !== undefined" [attr.title]="col!.enum![getData(row, col)]">
                        <i *ngIf="col.iconCls" [ngClass]="col.iconCls.cls" [ngStyle]="col.iconCls.css"></i>
                        {{ col!.enum![getData(row, col)] }}
                      </span>
                      <span *ngIf="col?.enum && col.dataSrc && getRowValue(row, [col.dataSrc]) && col!.enum![getRowValue(row, [col.dataSrc])] === undefined" [attr.title]="getData(row, col)">
                        <i *ngIf="col.iconCls" [ngClass]="col.iconCls.cls" [ngStyle]="col.iconCls.css"></i>
                        {{ getData(row, col) }}
                        <!--{{ col.suffix != false ? col.suffix : '' }}-->
                      </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'currency'">
                      <span [attr.title]="col?.dataSrc && row && getRowValue(row, [col!.dataSrc!]) ? getRowValue(row, [col!.dataSrc!]) : ''" [class.ig-color-warning-red]="col.currencyColourCoding && getRowValue(row, [col!.dataSrc!]) <= 0" [class.ig-color-success-green]="col.currencyColourCoding && getRowValue(row, [col!.dataSrc!]) > 0">
                        <i *ngIf="col.iconCls" [ngClass]="col.iconCls.cls" [ngStyle]="col.iconCls.css"></i>
                        {{ col.prefix }}
                        <ng-container *ngIf="col.currencyColourCoding && getRowValue(row, [col!.dataSrc!]) > 0">+</ng-container>{{ getData(row, col) | currency: (col.currencySymbol | async) || 'EUR':'symbol':col.currencyDigitsInfo || undefined }}
                        <span *ngIf="(getData(row, col) | currency: (col.currencySymbol | async) || 'EUR':'symbol':col.currencyDigitsInfo || undefined) !== null">{{ col.suffix }}</span>
                      </span>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <span [attr.title]="row && col?.dataSrc && getRowValue(row, [col!.dataSrc!]) ? getRowValue(row, [col!.dataSrc!]) : ''">
                        <i *ngIf="col.iconCls" [ngClass]="col.iconCls.cls" [ngStyle]="col.iconCls.css"></i>
                        {{ col.prefix }}
                        <span [innerHtml]="getData(row, col)" [style]="col.truncate && 'white-space: nowrap; overflow: hidden; text-overflow: ellipsis'"></span>
                        {{ col.suffix }}
                      </span>
                    </ng-container>
                  </div>
                </td>
              </ng-container>
              <td *ngIf="hasHelperCell" class="ig-data-table__cell-helper">
                <div *ngIf="this.busyRows?.length" class="ig-data-table__loading-bar"></div>
              </td>
            </tr>
          </ng-container>

        </tbody>

        <!-- Fake rows that are visible when more content is loading -->
        <tfoot *ngIf="loadingNext">
          <tr *ngFor="let _ of [].constructor(visibilityStep)">
            <td *ngIf="fixedFirstColumn">
              <div class="ig-data-table__cell-inner">
                <ig-loader></ig-loader>
              </div>
            </td>
            <td class="ig-data-table__empty-cell">
              <div class="ig-data-table__cell-inner">
                <ig-loader *ngIf="!fixedFirstColumn"></ig-loader>
              </div>
            </td>
            <td *ngIf="fixedLastColumn"><div class="ig-data-table__cell-inner">&nbsp;</div></td>
            <td *ngIf="hasHelperCell"><div class="ig-data-table__cell-inner"></div></td>
          </tr>
        </tfoot>
      </table>

      <!-- Table sticky header -->
      <table class="ig-data-table ig-data-table__sticky-header" #igStickyHeader [class.ig-data-table--display-grid]="tableGrid" [ngClass]="{'ig-data-table__sticky-header--fixed': fixedTableHeader, 'ig-data-table__sticky-header--fixed-bottom': fixedBottomTableHeader}">
        <ng-container *ngIf="fixedHeader" [ngTemplateOutlet]="tableHeader"></ng-container>
      </table>

    </div>

  </div>


</div>
